// extracted by mini-css-extract-plugin
export var link = "_sm-0";